<template>
  <el-dialog :visible="isShowDialog" @close="closePopup()" width="100%" top="40px" style="padding: 0 40px">
    <div class="page-header" style="top: -30px;">{{ title }}</div>
    <span id="modal-body">
      <el-form ref="form" label-width="10%" style="width: 100%">
        <el-form-item>
          <el-col :span="21">
            <div class="label-required">{{$t('senderName')}}</div>
            <el-select v-model="hotelId" style="width: 100%" filterable>
              <el-option
                v-for="sender in senderList"
                :key="sender.hotelId"
                :label="`${sender.name} (${sender.hotelName})`"
                :value="sender.hotelId">
              </el-option>
              <el-option :label="$t('otherSenderName')" value="0"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-if="hotelId === '0'">
          <el-col :span="21">
            <el-input type="text" v-model="senderName"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="21">
            <div class="label-required">{{$t('replyEmail')}}</div>
            <el-input type="text" v-model="replyEmail"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="21">
            <el-row>
              <div class="label-required" style="float: left">{{$t('toEmail')}}</div>
              <span class="email-list-input-msg" v-show="isShowInput.toEmail">
                {{ $t('useCommaToSeparateEmailMessage') }}
              </span>
            </el-row>
            <el-input type="text" v-model="toEmailInput" v-show="isShowInput.toEmail"></el-input>
            <el-button plain size="mini" class="button-default-email"
                       v-for="toEmail in toDefaultList" :key="toEmail">
              {{ toEmail }}
              <i class="el-icon-minus remove-email-icon"
                 @click="onRemoveEmailListButtonClick('toEmail', toEmail)"></i>
            </el-button>
            <el-button plain type="primary" size="mini" icon="el-icon-plus" class="add-email-icon"
                       @click="isShowInput.toEmail = true" v-show="!isShowInput.toEmail">
              {{$t('addEmail')}}
            </el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="21">
            <el-row>
              <div style="float: left">{{$t('ccEmail')}}</div>
              <span class="email-list-input-msg" v-show="isShowInput.ccEmail">
                {{ $t('useCommaToSeparateEmailMessage') }}
              </span>
            </el-row>
            <el-input type="text" v-model="ccEmailInput" v-show="isShowInput.ccEmail"></el-input>
            <el-button plain size="mini" class="button-default-email"
                       v-for="ccEmail in ccDefaultList" :key="ccEmail">
              {{ ccEmail }}
              <i class="el-icon-minus remove-email-icon"
                 @click="onRemoveEmailListButtonClick('ccEmail', ccEmail)"></i>
            </el-button>
            <el-button plain type="primary" size="mini" icon="el-icon-plus" class="add-email-icon"
                       v-show="!isShowInput.ccEmail" @click="isShowInput.ccEmail = true">
              {{$t('addEmail')}}
            </el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="21">
            <el-row>
              <div style="float: left">{{$t('bccEmail')}}</div>
              <span class="email-list-input-msg" v-show="isShowInput.bccEmail">
                {{ $t('useCommaToSeparateEmailMessage') }}
              </span>
            </el-row>
            <el-input type="text" v-model="bccEmailInput" v-show="isShowInput.bccEmail"></el-input>
            <el-button plain size="mini" class="button-default-email"
                       v-for="bccEmail in bccDefaultList" :key="bccEmail">
              {{ bccEmail }}
              <i class="el-icon-minus remove-email-icon"
                 @click="onRemoveEmailListButtonClick('bccEmail', bccEmail)"></i>
            </el-button>
            <el-button plain type="primary" size="mini" icon="el-icon-plus" class="add-email-icon"
                       @click="isShowInput.bccEmail = true" v-show="!isShowInput.bccEmail">
              {{$t('addEmail')}}
            </el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="21">
            <div class="label-required">{{$t('subject')}}</div>
            <el-input type="text" v-model="emailSubject"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="21">
            <div class="label-required">{{$t('body')}}</div>
            <vue-editor v-model="emailBody" :editorToolbar="customToolbar"></vue-editor>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="21">
            <div>{{$t('attachment')}}</div>
            <el-button plain size="mini" v-for="(attachment, index) in attachmentList"
                       :key="`${attachment.name}-${index}`" class="button-default-email">
              {{ attachment.name }}
              <i class="el-icon-minus remove-email-icon"
                 @click="onRemoveAttachmentListButtonClick(attachment.name, index)"></i>
            </el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="">
          <el-col :span="21" style="margin-top: 25px" class="text-right">
            <el-button type="default" @click="closePopup">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="onSendEmailButtonClick">{{ $t('sendEmail') }}</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </span>
  </el-dialog>
</template>

<script>
import i18nMessages from '@/translations/components/PopupSendEmailComponent.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import EmailApi from '@/api/email-api'
import { VueEditor } from 'vue2-editor'
import { get } from 'lodash'

const EMAIL_TYPE = {
  TO: 'to',
  CC: 'cc',
  BCC: 'bcc'
}

export default {
  name: 'PopupSendEmailComponent',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  i18n: { messages: i18nMessages },
  components: { VueEditor },
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Object,
      default: function () {
        return {
          hotelId: '',
          senderList: [],
          toEmailList: [],
          ccEmailList: [],
          bccEmailList: [],
          attachmentList: []
        }
      }
    },
    sendType: {
      type: String,
      default: ''
    },
    refCode: {
      type: String,
      default: ''
    },
    agent: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  created: function () {},
  data () {
    return {
      EMAIL_TYPE,
      isShowDialog: false,
      hotelId: '',
      isShowInput: {
        toEmail: false,
        ccEmail: false,
        bccEmail: false
      },
      toEmailInput: '',
      ccEmailInput: '',
      bccEmailInput: '',
      emailSubject: '',
      emailBody: '',
      senderList: [],
      senderName: '',
      replyEmail: '',
      toDefaultList: [],
      ccDefaultList: [],
      bccDefaultList: [],
      attachmentList: [],
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [
          { list: 'ordered' },
          { list: 'bullet' },
          { list: 'check' }
        ],
        [
          { 'color': [] },
          { 'background': [] }
        ]
      ]
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
    },
    hotelId: function (newValue) {
      const sender = this.senderList.find(sender => sender.hotelId === newValue)
      this.replyEmail = (sender === undefined) ? '' : sender.replyEmail
    },
    initData: function (value) {
      this.hotelId = value.hotelId
      this.senderList = value.senderList
      this.toDefaultList = value.toEmailList.filter((email) => {
        return (email.trim()) !== ''
      })
      this.ccDefaultList = value.ccEmailList.filter((email) => {
        return (email.trim()) !== ''
      })
      this.bccDefaultList = value.bccEmailList.filter((email) => {
        return (email.trim()) !== ''
      })
      this.attachmentList = value.attachmentList
    }
  },
  methods: {
    onRemoveAttachmentListButtonClick: async function (attachmentName, index) {
      this.attachmentList = this.attachmentList.filter((attachment, attachmentIndex) => {
        return attachmentIndex !== index
      })
    },
    onRemoveEmailListButtonClick: async function (emailType, email) {
      switch (emailType) {
        case 'toEmail':
          this._removeToEmailList(email)
          break
        case 'ccEmail':
          this._removeCcEmailList(email)
          break
        case 'bccEmail':
          this._removeBccEmailList(email)
          break
      }
    },
    onSendEmailButtonClick: async function () {
      if (!this._validateData()) {
        return false
      }

      try {
        this.startLoading()

        const emailData = this._prepareEmailData()
        await EmailApi.send(emailData)

        this.closePopup()

        const title = this.$t('sendEmailContractSuccessTitle')
        const message = this.$t('sendEmailContractSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    _removeToEmailList: function (selectedToEmail) {
      this.toDefaultList = this.toDefaultList.filter(toEmail => toEmail !== selectedToEmail)
    },
    _removeCcEmailList: function (selectedCcEmail) {
      this.ccDefaultList = this.ccDefaultList.filter(ccEmail => ccEmail !== selectedCcEmail)
    },
    _removeBccEmailList: function (selectedBccEmail) {
      this.bccDefaultList = this.bccDefaultList.filter(bccEmail => bccEmail !== selectedBccEmail)
    },
    _prepareEmailData: function () {
      const toEmailList = this._prepareEmailList(EMAIL_TYPE.TO)
      const ccEmailList = this._prepareEmailList(EMAIL_TYPE.CC)
      const bccEmailList = this._prepareEmailList(EMAIL_TYPE.BCC)
      const senderName = this._prepareSenderName()
      const agentName = get(this.agent, 'name', '')
      const agentId = get(this.agent, 'id', '')
      const sendTo = this._prepareSendToList()

      const emailData = {
        hotelId: this.hotelId,
        sendType: this.sendType,
        sendTo: sendTo,
        subject: this.emailSubject,
        body: this.emailBody,
        replyEmail: this.replyEmail,
        senderName: senderName,
        emailList: [...toEmailList, ...ccEmailList, ...bccEmailList],
        attachments: this.attachmentList,
        detail: {
          refCode: this.refCode,
          agentId: agentId,
          agentName: agentName
        }
      }

      return emailData
    },
    _prepareEmailList: function (emailType) {
      const emailInputList = this._prepareEmailInputListByEmailType(emailType)
      const filteredEmailList = emailInputList.filter(email => email.trim() !== '')
      let defaultEmailList = []

      switch (emailType) {
        case EMAIL_TYPE.TO:
          defaultEmailList.push(...this.toDefaultList)
          break
        case EMAIL_TYPE.CC:
          defaultEmailList.push(...this.ccDefaultList)
          break
        case EMAIL_TYPE.BCC:
          defaultEmailList.push(...this.bccDefaultList)
          break
      }

      const resultEmailInputList = filteredEmailList.map((item) => {
        return {
          email: item.trim(),
          emailType: emailType
        }
      })

      const resultEmailDefaultList = defaultEmailList.map((item) => {
        return {
          email: item,
          emailType: emailType
        }
      })

      const result = [ ...resultEmailDefaultList, ...resultEmailInputList ]

      return result
    },
    _prepareEmailInputListByEmailType: function (emailType) {
      let emailInputList

      switch (emailType) {
        case EMAIL_TYPE.TO:
          emailInputList = this.toEmailInput.split(',')
          break
        case EMAIL_TYPE.CC:
          emailInputList = this.ccEmailInput.split(',')
          break
        case EMAIL_TYPE.BCC:
          emailInputList = this.bccEmailInput.split(',')
          break
      }

      return emailInputList
    },
    _prepareSendToList: function () {
      const toList = this._prepareEmailInputListByEmailType(EMAIL_TYPE.TO)
      const ccList = this._prepareEmailInputListByEmailType(EMAIL_TYPE.CC)
      const bccList = this._prepareEmailInputListByEmailType(EMAIL_TYPE.BCC)
      const toEmailList = _prepareSendToEmailList(this.toDefaultList, toList)
      const ccEmailList = _prepareSendToEmailList(this.ccDefaultList, ccList)
      const bccEmailList = _prepareSendToEmailList(this.bccDefaultList, bccList)

      const sendTo = {
        toList: toEmailList,
        ccList: ccEmailList,
        bccList: bccEmailList
      }

      return sendTo
    },
    _prepareSenderName: function () {
      const sender = this.senderList.find(sender => sender.hotelId === this.hotelId)

      return (sender === undefined) ? this.senderName : sender.name
    },
    _validateData: function () {
      let message
      const toEmailList = this._prepareEmailList(EMAIL_TYPE.TO)

      if (toEmailList.length === 0) {
        message = this.$t('pleaseEnterToEmail')
        this.alertError(message)

        return false
      }

      if (this.emailSubject === '') {
        message = this.$t('pleaseEnterEmailSubject')
        this.alertError(message)

        return false
      }

      if (this.emailBody === '') {
        message = this.$t('pleaseEnterEmailBody')
        this.alertError(message)

        return false
      }

      return true
    },
    closePopup: function () {
      this.isShowDialog = false
      this.clear()
      this.$emit('onClose')
    },
    clear: function () {
      this.senderList = []
      this.hotelId = '0'
      this.senderName = ''
      this.replyEmail = ''
      this.toEmailInput = ''
      this.ccEmailInput = ''
      this.bccEmailInput = ''
      this.emailSubject = ''
      this.emailBody = ''
      this.toDefaultList = []
      this.ccDefaultList = []
      this.bccDefaultList = []
      this.attachmentList = []
      this.isShowInput.toEmail = false
      this.isShowInput.ccEmail = false
      this.isShowInput.bccEmail = false
    }
  }
}

function _prepareSendToEmailList (defaultEmailList, additionalEmailList) {
  const combinedEmailList = [...defaultEmailList, ...additionalEmailList]
  const emailList = combinedEmailList.filter(email => (email.trim() !== ''))

  return emailList
}
</script>

<style scoped>
  .email-list-input-msg {
    padding-left: 5px;
    color: #9e9e9e;
    font-style: italic;
    position: relative;
    top: 10px;
    float: right;
  }
  .el-form > div {
    text-align: left;
  }
  .add-email-icon {
    padding: 9px 15px;
  }
  .remove-email-icon {
    padding: 2px;
    margin-left: 5px;
    border-radius: 10px;
    background: #f00;
    color: #fff;
  }
  .label-required:after {
    content: '*';
    color: #F56C6C;
    margin-left: 4px;
  }
  .button-default-email {
    background-color: #f0f0f0;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
</style>
